import AiManagerDashboard from './AiManagerDashboard';

export default {
  Dashboard: AiManagerDashboard,
};
